import React, { useContext, useEffect, useState } from "react";
import { Pagination } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import TableContainer from "../../../Components/Table/TableContainer";
import TableHeader from "../../../Components/Table/TableHeader";
import TableCell from "../../../Components/Table/TableCell";
import TableFooter from "../../../Components/Table/TableFooter";
import InnerCell from "../../../Components/Table/InnerCell";
import Button from "../../../Components/Button/Button";
import TableSkeleton from '../../../Components/Table/TableSkeleton';
import { useFlService } from '../../../Services/FlSubjectService';
import { useUlService } from '../../../Services/UlSubjectService';

import plusIcon from "../../../icons/XCircle.svg";
import styles from "./customers.table.module.css";
import Badge from '../../../Components/Badge/Badge';


export default function CustomersTable() {
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [type, setType] = useState("fl");

  const { getFlSubjectsPage } = useFlService();
  const { getUlSubjectsPage } = useUlService();

  const handleChange = (e, number) => {
    setPage(number);
  };

  async function getCustomers() {
    const fetchCustomersPage = type === "fl" ? getFlSubjectsPage : getUlSubjectsPage;
    const response = await fetchCustomersPage(page, pageCount);

    setCustomers(response.Data);
    setTotal(response.Total);
  }

  useEffect(() => {
    getCustomers()
  }, [page, type])

  return (
    <div className={styles.container}>
      <div style={{ display: "flex", flexDirection: "row", gap: 12 }}>
        <Button
          type='white'
          isDisabled={type === "fl"}
          onClick={() => {
            setType("fl")
            setCustomers([])
          }}
          text="Физ Лица"
        />
        <Button
          type='white'
          isDisabled={type === "ul"}
          onClick={() => { setType("ul"); setCustomers([]) }} text="Юр Лица"/>
      </div>
      <TableContainer>
        <TableHeader>
          {type === "fl" &&
            <React.Fragment>
              <TableCell th="Клиент/Тип"/>
              <TableCell th="Контакты"/>
              <TableCell th="СНИЛС"/>
              <TableCell th="Дата создания"/>
              <TableCell th="ЭП"/>
            </React.Fragment>
          }
          {type === "ul" &&
            <React.Fragment>
              <TableCell th="Клиент/Тип"/>
              <TableCell th="Контакты"/>
              <TableCell th="ИНН"/>
              <TableCell th="КПП"/>
              <TableCell th="ОГРН"/>
              <TableCell th="Дата создания"/>
            </React.Fragment>
          }
        </TableHeader>
        <tbody>
        {customers.length === 0 &&
          <TableSkeleton col={pageCount} row={type === "fl" ? 5 : 6} />
        }
        {type === "fl" && customers.map((x) =>
          <tr key={x.Id} onClick={() => navigate(`/customer/edit/${x.Id}/fl`)}>
            <TableCell title={`${x.Lastname} ${x.Firstname} ${x.Middlename}`} subtitle="Физ.лицо"/>
            <TableCell title={x.Phone} subtitle={x.Email} />
            <TableCell title={x.Snils}/>
            <TableCell title={x.DateCreate} />
            <TableCell status={<Badge type="success" text={x.certificate}/>}/>
          </tr>
        )}
        {type === "ul" && customers.map((x) =>
          <tr key={x.Id} onClick={() => navigate(`/customer/edit/${x.Id}/ul`)}>
            <TableCell title={x.Name} subtitle="Юр.лицо"/>
            <TableCell title={x.Phone} subtitle={x.Email} />
            <TableCell title={x.Inn}/>
            <TableCell title={x.Kpp}/>
            <TableCell title={x.Ogrn}/>
            <TableCell title={x.DateCreate} />
          </tr>
        )}
        </tbody>
      </TableContainer>
      <TableFooter>
        <Pagination
          count={Math.ceil(total / pageCount)}
          page={page}
          onChange={handleChange}
          variant="outlined"
          color="secondary"
        />
      </TableFooter>
    </div>
  )
}